/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PlayersRouteImport } from './routes/players'
import { Route as AppRouteImport } from './routes/app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LibraryIndexRouteImport } from './routes/library/index'
import { Route as LibraryCreatureNewRouteImport } from './routes/library/creature/new'
import { Route as LibraryCreatureIdRouteImport } from './routes/library/creature/$id'
import { Route as LibraryCategoryNewRouteImport } from './routes/library/category/new'
import { Route as LibraryCategoryIdRouteImport } from './routes/library/category/$id'

const PlayersRoute = PlayersRouteImport.update({
  id: '/players',
  path: '/players',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryIndexRoute = LibraryIndexRouteImport.update({
  id: '/library/',
  path: '/library/',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryCreatureNewRoute = LibraryCreatureNewRouteImport.update({
  id: '/library/creature/new',
  path: '/library/creature/new',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryCreatureIdRoute = LibraryCreatureIdRouteImport.update({
  id: '/library/creature/$id',
  path: '/library/creature/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryCategoryNewRoute = LibraryCategoryNewRouteImport.update({
  id: '/library/category/new',
  path: '/library/category/new',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryCategoryIdRoute = LibraryCategoryIdRouteImport.update({
  id: '/library/category/$id',
  path: '/library/category/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRoute
  '/players': typeof PlayersRoute
  '/library/': typeof LibraryIndexRoute
  '/library/category/$id': typeof LibraryCategoryIdRoute
  '/library/category/new': typeof LibraryCategoryNewRoute
  '/library/creature/$id': typeof LibraryCreatureIdRoute
  '/library/creature/new': typeof LibraryCreatureNewRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/app': typeof AppRoute
  '/players': typeof PlayersRoute
  '/library': typeof LibraryIndexRoute
  '/library/category/$id': typeof LibraryCategoryIdRoute
  '/library/category/new': typeof LibraryCategoryNewRoute
  '/library/creature/$id': typeof LibraryCreatureIdRoute
  '/library/creature/new': typeof LibraryCreatureNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRoute
  '/players': typeof PlayersRoute
  '/library/': typeof LibraryIndexRoute
  '/library/category/$id': typeof LibraryCategoryIdRoute
  '/library/category/new': typeof LibraryCategoryNewRoute
  '/library/creature/$id': typeof LibraryCreatureIdRoute
  '/library/creature/new': typeof LibraryCreatureNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/players'
    | '/library/'
    | '/library/category/$id'
    | '/library/category/new'
    | '/library/creature/$id'
    | '/library/creature/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/app'
    | '/players'
    | '/library'
    | '/library/category/$id'
    | '/library/category/new'
    | '/library/creature/$id'
    | '/library/creature/new'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/players'
    | '/library/'
    | '/library/category/$id'
    | '/library/category/new'
    | '/library/creature/$id'
    | '/library/creature/new'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRoute
  PlayersRoute: typeof PlayersRoute
  LibraryIndexRoute: typeof LibraryIndexRoute
  LibraryCategoryIdRoute: typeof LibraryCategoryIdRoute
  LibraryCategoryNewRoute: typeof LibraryCategoryNewRoute
  LibraryCreatureIdRoute: typeof LibraryCreatureIdRoute
  LibraryCreatureNewRoute: typeof LibraryCreatureNewRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/players': {
      id: '/players'
      path: '/players'
      fullPath: '/players'
      preLoaderRoute: typeof PlayersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library/': {
      id: '/library/'
      path: '/library'
      fullPath: '/library/'
      preLoaderRoute: typeof LibraryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library/creature/new': {
      id: '/library/creature/new'
      path: '/library/creature/new'
      fullPath: '/library/creature/new'
      preLoaderRoute: typeof LibraryCreatureNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library/creature/$id': {
      id: '/library/creature/$id'
      path: '/library/creature/$id'
      fullPath: '/library/creature/$id'
      preLoaderRoute: typeof LibraryCreatureIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library/category/new': {
      id: '/library/category/new'
      path: '/library/category/new'
      fullPath: '/library/category/new'
      preLoaderRoute: typeof LibraryCategoryNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library/category/$id': {
      id: '/library/category/$id'
      path: '/library/category/$id'
      fullPath: '/library/category/$id'
      preLoaderRoute: typeof LibraryCategoryIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRoute,
  PlayersRoute: PlayersRoute,
  LibraryIndexRoute: LibraryIndexRoute,
  LibraryCategoryIdRoute: LibraryCategoryIdRoute,
  LibraryCategoryNewRoute: LibraryCategoryNewRoute,
  LibraryCreatureIdRoute: LibraryCreatureIdRoute,
  LibraryCreatureNewRoute: LibraryCreatureNewRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
